import { motion } from "framer-motion"
import { FaRocket, FaTimes, FaBars } from "react-icons/fa"
import { Link } from "react-scroll"
import { WhatsappLink } from ".."
import { useEffect, useState } from "react"
import { navItems } from ".."

const NavBar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
        const scrollY = window.scrollY;
        setIsScrolled(scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [])

  return (
          <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className={`fixed w-full z-50 transition-all duration-500 ease-out ${isScrolled
          ? "bg-white/95 backdrop-blur-xl py-3 shadow-lg"
          : "py-4 md:bg-transparent md:py-6"
          }`}
      >
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          {/* Logo Section */}
          <div className="flex items-center space-x-3">
            <div className="relative">
              <img
                src="/images/Dineai.ico"
                alt="Dine.AI logo"
                className="w-12 h-12 rounded-xl "
              />
            </div>
            <span
              className={`font-bold uppercase transition-all duration-300 text-2xl ${isScrolled
                ? "text-orange-600"
                : "text-white "
                }`}
            >
              Dine.AI
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className={`hidden lg:flex items-center space-x-8 ${isScrolled ? "text-gray-700" : "text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)]"
            }`}>
            {navItems.map((item, index) => (
              <motion.div
                key={item.name}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Link
                  to={item.to}
                  smooth={true}
                  duration={800}
                  offset={-70}
                  className="relative group cursor-pointer font-medium hover:text-orange-400 transition-all duration-300"
                >
                  {item.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-orange-400 to-orange-500 group-hover:w-full transition-all duration-300"></span>
                </Link>
              </motion.div>
            ))}

            {/* CTA Button */}
            <a
              href={WhatsappLink}
              className="group relative px-6 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden hover:scale-105"
            >
              <span className="relative z-10 flex items-center gap-2">
                <FaRocket className="text-sm" />
                Get Started
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-orange-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`lg:hidden p-2 rounded-lg transition-all duration-300 ${isScrolled
              ? "text-gray-700 hover:bg-orange-50"
              : "text-white hover:bg-white/10"
              }`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <div className={`transition-transform duration-300 ${mobileMenuOpen ? 'rotate-180' : ''}`}>
              {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </div>
          </button>
        </div>

        {/* Enhanced Mobile Menu */}
        <div
          className={`lg:hidden overflow-hidden bg-white/95 backdrop-blur-xl border-t border-orange-100 transition-all duration-300 ease-in-out ${mobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
        >
          <div className="px-6 py-6 space-y-6">
            {navItems.map((item, index) => (
              <motion.div
                key={item.name}
                initial={{ opacity: 0, x: -20 }}
                animate={{
                  opacity: mobileMenuOpen ? 1 : 0,
                  x: mobileMenuOpen ? 0 : -20
                }}
                transition={{ delay: index * 0.1 }}
              >
                <Link
                  to={item.to}
                  smooth={true}
                  duration={800}
                  offset={-70}
                  className="block text-gray-700 hover:text-orange-500 font-medium transition-colors duration-300"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              </motion.div>
            ))}

            <a
              href={WhatsappLink}
              className="flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
              onClick={() => setMobileMenuOpen(false)}
            >
              <FaRocket className="text-sm" />
              Start Cooking 🍳
            </a>
          </div>
        </div>
      </motion.nav>
  )
}

export default NavBar